import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "col-fixed align-self-end align-items-center" }
const _hoisted_8 = {
  key: 0,
  class: "pi pi-lock-open",
  style: {"font-size":"1.5rem"}
}
const _hoisted_9 = {
  key: 1,
  class: "pi pi-lock",
  style: {"font-size":"1.5rem"}
}
const _hoisted_10 = {
  style: {"margin":"10px"},
  class: "flex"
}
const _hoisted_11 = { class: "w-100pc p-input-icon-left p-input-icon-right" }
const _hoisted_12 = { class: "col-12 property-service-item hover-row" }
const _hoisted_13 = { class: "grid flex-nowrap" }
const _hoisted_14 = { class: "col-3 md:col-2 ml-2 compass-red" }
const _hoisted_15 = { class: "col-3 service-name compass-red" }
const _hoisted_16 = { class: "col-fixed hidden lg:block service-ref" }
const _hoisted_17 = { class: "col-fixed hidden xl:block service-type" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "text-center col-1" }
const _hoisted_20 = { class: "col-3 hidden md:block" }
const _hoisted_21 = {
  key: 1,
  class: "flex"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "col-fixed text-right service-price" }
const _hoisted_25 = {
  key: 0,
  class: "grid flex-nowrap p-2"
}
const _hoisted_26 = { class: "mt-2 ml-2" }
const _hoisted_27 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DataView = _resolveComponent("DataView")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("h3", null, "Company Pricing Summary", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Multiselect, {
                options: _ctx.activeCustomersWithProperties,
                searchable: true,
                limit: 40,
                filter: true,
                class: "flex",
                modelValue: _ctx.selectedCompanyId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCompanyId) = $event)),
                valueProp: "id",
                label: "nameAndId",
                "track-by": "nameAndId",
                placeholder: "Select a customer",
                onSelect: _ctx.changeCompany
              }, null, 8, ["options", "modelValue", "onSelect"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
                key: 0,
                style: {"width":"40px","height":"40px"},
                strokeWidth: "3"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editMode=!_ctx.editMode))
          }, [
            (_ctx.editMode)
              ? (_openBlock(), _createElementBlock("i", _hoisted_8))
              : _createCommentVNode("", true),
            (!_ctx.editMode)
              ? (_openBlock(), _createElementBlock("i", _hoisted_9))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[4] || (_cache[4] = _createElementVNode("i", { class: "pi pi-home" }, null, -1)),
          _createVNode(_component_InputText, {
            modelValue: _ctx.companyServicesFilter,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companyServicesFilter) = $event)),
            placeholder: "Service keyword filter.."
          }, null, 8, ["modelValue"]),
          _cache[5] || (_cache[5] = _createElementVNode("i", { class: "pi pi-search" }, null, -1))
        ])
      ]),
      _createVNode(_component_DataView, {
        value: _ctx.filteredServices,
        datakey: "propertyServiceId",
        paginator: true,
        rows: 10,
        scrollable: true,
        stripedRows: "",
        class: "p-datatable-sm property-service-table",
        paginatorTemplate: _ctx.paginatorTemplate,
        rowsPerPageOptions: [10,20,50,100,200],
        responsiveLayout: "scroll",
        alwaysShowPaginator: false,
        currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
      }, {
        header: _withCtx(() => [...(_cache[6] || (_cache[6] = [
          _createElementVNode("div", { class: "col-12" }, [
            _createElementVNode("div", { class: "grid flex-nowrap" }, [
              _createElementVNode("div", { class: "col-3 md:col-2" }, "Property Name"),
              _createElementVNode("div", { class: "col-3" }, "Service"),
              _createElementVNode("div", { class: "col-fixed hidden lg:block service-ref" }, "Ref"),
              _createElementVNode("div", { class: "col-fixed hidden xl:block service-type" }, "Type"),
              _createElementVNode("div", { class: "text-center col-1" }, "Anniversary"),
              _createElementVNode("div", { class: "col-3 hidden md:block" }, "Supplier"),
              _createElementVNode("div", { class: "col-fixed text-right service-price" }, "Price / Interval")
            ])
          ], -1)
        ]))]),
        list: _withCtx(({data}) => [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                  to: { name: 'PropertyDetails', params: { propertyId: data.propertyId }}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.propertyName), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])), [
                  [
                    _directive_tooltip,
                    data.buildingName,
                    void 0,
                    { top: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_router_link, {
                  to: { name: 'PropertyDetails', params: { propertyId: data.propertyId }}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.serviceName), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", null, _toDisplayString(data.ref), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                (data.serviceType)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(data.serviceType.replace(' Service','')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", null, _toDisplayString(_ctx.formattedDate(data.whenNextServiceAnniversary)), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock(_component_Multiselect, {
                      key: 0,
                      options: _ctx.supplierList,
                      searchable: true,
                      limit: 40,
                      filter: true,
                      class: "flex",
                      modelValue: data.supplierCompanyId,
                      "onUpdate:modelValue": ($event: any) => ((data.supplierCompanyId) = $event),
                      valueProp: "id",
                      label: "nameAndId",
                      "track-by": "nameAndId",
                      placeholder: "Select a Supplier",
                      onSelect: ($event: any) => (_ctx.updateSupplierName(data)),
                      onClear: ($event: any) => (_ctx.clearSupplierName(data))
                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect", "onClear"]))
                  : _createCommentVNode("", true),
                (!_ctx.editMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (data.supplierName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(data.supplierName), 1))
                        : _createCommentVNode("", true),
                      _cache[8] || (_cache[8] = _createTextVNode("   ", -1)),
                      (data.supplierCompanyId)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.toggleSupplierDetails(data.supplierCompanyId))
                          }, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("i", { class: "pi pi-info-circle" }, null, -1)
                          ]))], 8, _hoisted_23))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_24, [
                (_ctx.editMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createVNode(_component_InputNumber, {
                        mode: "decimal",
                        modelValue: data.price,
                        "onUpdate:modelValue": ($event: any) => ((data.price) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_26, [
                        _createTextVNode(_toDisplayString(data.intervalMonths), 1)
                      ])), [
                        [
                          _directive_tooltip,
                          'invoicing interval',
                          void 0,
                          { top: true }
                        ]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.editMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("span", null, "$" + _toDisplayString(data.price) + " /", 1),
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode(_toDisplayString(data.intervalMonths), 1)
                      ])), [
                        [
                          _directive_tooltip,
                          'invoicing interval',
                          void 0,
                          { top: true }
                        ]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        empty: _withCtx(() => [...(_cache[9] || (_cache[9] = [
          _createElementVNode("div", { class: "text-center pt-2 pb-2" }, " No records found. ", -1)
        ]))]),
        _: 1
      }, 8, ["value", "paginatorTemplate"])
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          class: "sticky-button cancel",
          icon: "pi pi-times",
          label: _ctx.hasChanges ? 'Cancel' : 'Close',
          onClick: _ctx.cancel
        }, null, 8, ["label", "onClick"]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 2,
          class: "sticky-button",
          icon: "pi pi-check",
          label: "Save",
          onClick: _ctx.save,
          disabled: !_ctx.hasChanges
        }, null, 8, ["onClick", "disabled"]))
      : _createCommentVNode("", true)
  ], 64))
}